import { addAltText, bindKeymapWithCommand, escape } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { closeMediaAltTextMenu, openMediaAltTextMenu } from './commands';
export default function keymapPlugin(schema, editorAnalyticsAPI) {
  var list = {};

  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  bindKeymapWithCommand(addAltText.common, openMediaAltTextMenu(editorAnalyticsAPI), list);

  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  bindKeymapWithCommand(escape.common, closeMediaAltTextMenu, list);
  return keymap(list);
}